import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
const Home = lazy(() => import('./pages/Home'));
const Apoyar = lazy(() => import('./pages/Apoyar'));
const Autor = lazy(() => import('./pages/Autor'));
const ComoFunciona = lazy(() => import('./pages/ComoFunciona'));
const Comentarios = lazy(() => import('./pages/Comentarios'));
const AcercaDe = lazy(() => import('./pages/AcercaDe'));
const Privacidad = lazy(() => import('./pages/Privacidad'));

function Loading() {
  return <div className="flex flex-col items-center justify-center gap-3 py-20 text-[var(--color-text-secondary)]">Cargando...</div>;
}

export function router() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/apoyar" element={<Apoyar />} />
        <Route path="/autor" element={<Autor />} />
        <Route path="/como-funciona" element={<ComoFunciona />} />
        <Route path="/comentarios" element={<Comentarios />} />
        <Route path="/acerca-de" element={<AcercaDe />} />
        <Route path="/privacidad" element={<Privacidad />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
